/** Pluggable `[0, 1)` random source. Inject via `EngineCtx.rng` for determinism. */
export interface Rng {
  next(): number;
}

/** Mulberry32-style deterministic RNG. Same seed → same stream. */
export const seededRng = (seed: number): Rng => {
  let s = seed >>> 0;
  return {
    next() {
      s = (s + 0x6d2b79f5) >>> 0;
      let t = s;
      t = Math.imul(t ^ (t >>> 15), t | 1);
      t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    },
  };
};

/** Non-deterministic `Math.random`-backed RNG for production rooms. */
export const cryptoRng = (): Rng => ({
  next: () => Math.random(),
});
